import { Injectable } from '@angular/core';
import { whmcsCurrency } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class PaidPublicationsService {
  private readonly prices: { [key: string]: { [key: number]: string } } = {
    EUR: {
      4: '50€',
      5: '100€',
      6: '100€',
    },
    GBP: {
      4: '£50',
      5: '£100',
      6: '£100',
    },
    USD: {
      4: '$50',
      5: '$100',
      6: '$100',
    },
  };

  getAddonPrice(currency: whmcsCurrency, planId: number): string {
    return this.prices[currency]?.[planId] || '';
  }

  isPlanSupported(planId: number): boolean {
    return Object.values(this.prices).some(currencyPrices =>
      currencyPrices.hasOwnProperty(planId),
    );
  }

  isCurrencySupported(currency: whmcsCurrency): boolean {
    return this.prices.hasOwnProperty(currency);
  }
}
